import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { reducers as globalReducers } from '@nextiva/global-store';
import {
  paymentReducer,
  billingLandingReducer,
  summaryReducer,
  invoicesReducer,
} from 'components';

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const store = () =>
  createStore(
    combineReducers({
      ...globalReducers,
      payment: paymentReducer,
      billingLanding: billingLandingReducer,
      summary: summaryReducer,
      invoices: invoicesReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

export default store;
